import { useFlagBasedOnJSONDomain } from '@components/Flag';

export const useCustomerV2Flag = (): boolean => {
  const useCustomerV2 = useFlagBasedOnJSONDomain(
    'ME-35786-feat-customer-migration-v2'
  );
  return useCustomerV2;
};
